import React, { useContext } from "react";
import { AddTenantContext } from "../AddTenantView";
import { Col, Container, Row } from "react-bootstrap";
import ContentData from "../../../../constants/contentFile.json";
import InputComponent from "../../../../components/InputComponent/InputComponent";
import "./addTenant.css";
import BorderButton from "../../../../components/BorderButton/BorderButton";
import ThemeButton from "../../../../components/ThemeButton/ThemeButton";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../../../constants/routeConstants.json";
import PopupAlertSuccess from "../../../../components/PopupAlertSuccess/PopupAlert";
import Loader from "../../../../components/Loader/Loader";
import SelectOption from "../../../../components/ThemeSelectOption/SelectOption";
import AddErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";
import NextIcon from "../../../../assets/images/next-icon.svg";
import ErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";

const AddTenant = () => {
  const {
    name,
    email,
    phone,
    setName,
    setEmail,
    setPhone,
    organizationName,
    setOrganizationName,
    organizationEmail,
    setOrganizationEmail,
    organizationType,
    setOrganizationType,
    location,
    setLocation,
    subscriptionPlan,
    createTenant,
    validationErrors,
    submitSuccessPopup,
    setSubmitSuccessPopup,
    handleBlur,
    handleSelectData,
    transformedPlans,
    spinnerStatus,
    addErrorPopup,
    setAddErrorPopup,
    errorAlertMessage,
    setErrorAlertMessage,
    errorPopup,
    setErrorPopup,
    getSubscriptionPlans,
    goToTenantList,

    errorPopupMessage,
    setErrorPopupMessage,
    buttonText,
    goToLogin,
    statusValue,
    setValidationErrors,
    validateName,
    validateEmail,
    validateMobileNumber,
    validateNameWithNum,
  } = useContext(AddTenantContext);
  const navigate = useNavigate();

  return (
    <div className="pageBg">
      <div className="breadCrums">
        <span className="breadCrumsPointing" onClick={goToTenantList}>
          {ContentData.tenantPage.pageTitle}
        </span>
        <img className="nextIcon" src={NextIcon} alt="next icon" />
        <span className="boldBreadCrums">
          {ContentData.tenantPage.addTenant}
        </span>
      </div>
      {spinnerStatus && <Loader />}

      <Container className="addTenantContainer">
        <div className="pageTittles">{ContentData.addTenant.pageTitle}</div>
        <form action="" onSubmit={createTenant}>
          <div className="basicContainer">
            <Row>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.addTenant.fullName}</h4>
                    <InputComponent
                      placeholder={ContentData.addTenant.enterName}
                      value={name}
                      onChange={(e) => {
                        const value = e.target.value;
                        const capitalizedValue =
                          value.charAt(0).toUpperCase() + value.slice(1);

                        setName(capitalizedValue);

                        if (validateName(value)) {
                          setValidationErrors((prevErrors) => ({
                            ...prevErrors,
                            name: "",
                          }));
                        }
                      }}
                      handleBlur={() => handleBlur("name")}
                    />
                    {validationErrors.name && (
                      <p className="mb-0 error-msg">{validationErrors.name}</p>
                    )}
                  </div>
                </div>
              </Col>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.addTenant.emailAddress}</h4>
                    <InputComponent
                      placeholder={ContentData.addTenant.enteremail}
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);

                        if (validateEmail(e.target.value)) {
                          setValidationErrors((prevErrors) => ({
                            ...prevErrors,
                            email: "",
                          }));
                        }
                      }}
                      handleBlur={() => handleBlur("email")}
                    />
                    {validationErrors.email && (
                      <p className="mb-0 error-msg">{validationErrors.email}</p>
                    )}
                  </div>
                </div>
              </Col>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.addTenant.phoneNumber}</h4>
                    <InputComponent
                      placeholder={ContentData.addTenant.enterPhoneNmber}
                      value={phone}
                      onChange={(e) => {
                        setPhone(e.target.value);

                        if (validateMobileNumber(e.target.value)) {
                          setValidationErrors((prevErrors) => ({
                            ...prevErrors,
                            phone: "",
                          }));
                        }
                      }}
                      handleBlur={() => handleBlur("phone")}
                    />
                    {validationErrors.phone && (
                      <p className="mb-0 error-msg">{validationErrors.phone}</p>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <div className="organisationDetailsTenant">
              {ContentData.addTenant.organisationDetails}
            </div>
            <Row>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.addTenant.name}</h4>
                    <InputComponent
                      placeholder={ContentData.addTenant.enterName}
                      value={organizationName}
                      onChange={(e) => {
                        const value = e.target.value;
                        const capitalizedValue =
                          value.charAt(0).toUpperCase() + value.slice(1);

                        setOrganizationName(capitalizedValue);

                        if (validateNameWithNum(capitalizedValue)) {
                          setValidationErrors((prevErrors) => ({
                            ...prevErrors,
                            organizationName: "",
                          }));
                        }
                      }}
                      handleBlur={() => handleBlur("organizationName")}
                    />
                    {validationErrors.organizationName && (
                      <p className="mb-0 error-msg">
                        {validationErrors.organizationName}
                      </p>
                    )}
                  </div>
                </div>
              </Col>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.addTenant.emailAddress}</h4>
                    <InputComponent
                      placeholder={ContentData.addTenant.enteremail}
                      value={organizationEmail}
                      onChange={(e) => {
                        setOrganizationEmail(e.target.value);

                        if (validateEmail(e.target.value)) {
                          setValidationErrors((prevErrors) => ({
                            ...prevErrors,
                            organizationEmail: "",
                          }));
                        }
                      }}
                      handleBlur={() => handleBlur("organizationEmail")}
                    />
                    {validationErrors.organizationEmail && (
                      <p className="mb-0 error-msg">
                        {validationErrors.organizationEmail}
                      </p>
                    )}
                  </div>
                </div>
              </Col>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.addTenant.type}</h4>
                    <InputComponent
                      placeholder={ContentData.addTenant.enterOrganizationType}
                      value={organizationType}
                      onChange={(e) => {
                        const value = e.target.value;
                        const capitalizedValue =
                          value.charAt(0).toUpperCase() + value.slice(1);

                        setOrganizationType(capitalizedValue);

                        if (capitalizedValue.trim()) {
                          setValidationErrors((prevErrors) => ({
                            ...prevErrors,
                            organizationType: "",
                          }));
                        }
                      }}
                      handleBlur={() => handleBlur("organizationType")}
                    />
                    {validationErrors.organizationType && (
                      <p className="mb-0 error-msg">
                        {validationErrors.organizationType}
                      </p>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.addTenant.location}</h4>
                    <InputComponent
                      placeholder={ContentData.addTenant.enterLocation}
                      value={location}
                      onChange={(e) => {
                        const value = e.target.value;
                        const capitalizedValue =
                          value.charAt(0).toUpperCase() + value.slice(1);
                        setLocation(capitalizedValue);

                        if (capitalizedValue.trim()) {
                          setValidationErrors((prevErrors) => ({
                            ...prevErrors,
                            location: "",
                          }));
                        }
                      }}
                      handleBlur={() => handleBlur("location")}
                    />
                    {validationErrors.location && (
                      <p className="mb-0 error-msg">
                        {validationErrors.location}
                      </p>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <div className="organisationDetailsTenant">
              {ContentData.addTenant.subscriptionDetails}
            </div>
            <Row>
              <Col xl="4" lg="6" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData.addTenant.subscriptionPlan}</h4>

                    <SelectOption
                      values={transformedPlans}
                      handleSelectData={handleSelectData}
                      selectNum="id"
                      label="displayName"
                      defaultValue={subscriptionPlan}
                      selectPlaceholder="Select an option"
                      handleBlur={() => handleBlur("subscriptionPlan")}
                    />

                    {validationErrors.subscriptionPlan && (
                      <p className="mb-0 error-msg">
                        {validationErrors.subscriptionPlan}
                      </p>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <div className="tenantBtnGrp">
              <BorderButton
                value={ContentData.addTenant.cancel}
                onClick={() => navigate(RouteConstants.TENANT_LIST)}
              />
              <ThemeButton
                value={ContentData.addTenant.submit}
                id="submitTenantAddBtn"
                type="submit"
              />
            </div>
          </div>
        </form>
      </Container>
      <PopupAlertSuccess
        show={submitSuccessPopup}
        setShow={setSubmitSuccessPopup}
        alertMessage={errorAlertMessage}
        handleSubmit={() => navigate(RouteConstants.TENANT_LIST)}
      />
      <AddErrorPopup
        show={addErrorPopup}
        setShow={setAddErrorPopup}
        alertMessage={errorAlertMessage}
        handleCancel={() => {
          setAddErrorPopup(false);
        }}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            goToLogin();
            setAddErrorPopup(false);
          } else {
            setAddErrorPopup(false);
            document.getElementById("submitTenantAddBtn").click();
          }
        }}
        cancelText={ContentData.tenantPage.cancel}
        buttonText={buttonText}
      />
      <ErrorPopup
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            goToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            getSubscriptionPlans();
          }
        }}
      />
    </div>
  );
};

export default AddTenant;
